interface Props {
  letter: string;
  children: React.ReactNode;
  filteredView?: boolean;
}

const PartnerLetter: React.FC<Props> = ({ children, letter, filteredView }) => {
  return (
    <div
      className={`filter-list__checkbox-item ${filteredView && 'filter-list__checkbox-item--filtered'}`}
      key={letter}
      data-key={letter}
    >
      <div className="filter-list__checkbox-item__key-name">{letter}</div>
      {children}
    </div>
  );
};

export default PartnerLetter;
